import {Section} from "../../@types/privacyPolicySectionResources.tsx";
import {Language} from "../../@types/generics.tsx";

export const ProhibitedActivitiesSectionsConfig: Section[] = [
    {
        heading: 'prohibited_activities_heading',
        paragraphs: [
            {
                text: 'prohibited_activities_paragraph_1',
                list: [
                    {
                        text: 'prohibited_activities_paragraph_1_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_8',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_9',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_10',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_11',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_12',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_13',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_14',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_15',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_16',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_17',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_18',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'prohibited_activities_paragraph_1_list_19',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ],
                languageToShow: [Language.LT, Language.EN]
            },
        ],
        languageToShow: [Language.LT, Language.EN]
    }
]
